import React, { FC, useContext } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { AppToasterContext } from './app-toaster-context';
import CheckIcon from '@mui/icons-material/Check';

const AppToaster: FC = () => {
    const { appToasterContent, setAppToasterContent } = useContext(AppToasterContext);

    const dialogClosed = () => {
        setAppToasterContent({ isOpen: false, severity: appToasterContent.severity });
    };

    return (
        <Snackbar
            autoHideDuration={8000}
            open={appToasterContent.isOpen}
            onClose={dialogClosed}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
            <Alert
                variant="filled"
                onClose={dialogClosed}
                severity={appToasterContent.severity}
                sx={{ minWidth: 320, boxShadow: 4 }}
                iconMapping={{
                    success: <CheckIcon fontSize="inherit" />,
                }}
            >
                {appToasterContent.message}
            </Alert>
        </Snackbar>
    );
};

export default AppToaster;
